import { FC, ReactNode } from 'react';
import { Page } from '@servicetitan/web-feature-ui';

export interface FinancingPageWrapperProps {
    children: ReactNode;
    headerActions?: ReactNode;
    showHeaders?: boolean;
}

export const FinancingPageWrapper: FC<FinancingPageWrapperProps> = ({
    children,
    headerActions,
    showHeaders = false,
}) => {
    return (
        <Page>
            {showHeaders && <Page.Header title="Apply for Financing">{headerActions}</Page.Header>}
            <Page.Content>{children}</Page.Content>
        </Page>
    );
};
